import axios from '@/libs/axios'
import crudActions from '@/store/crudActions'

const endpoint = 'monitoring-report'

const Actions = crudActions(endpoint)

const create = (ctx, data) => axios.post(`/${endpoint}/monitoring_report_create/`, data)

const list = (commit, queryParams, type) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/${type}/`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const monitoringReportAdvisorList = ({ commit }, queryParams) => list(commit, queryParams, 'monitoringReportAdvisorList')
const monitoringReportDoctorateList = ({ commit }, queryParams) => list(commit, queryParams, 'monitoringReportDoctorateList')
const monitoringReportInnovationList = ({ commit }, queryParams) => list(commit, queryParams, 'monitoringReportInnovationList')
const monitoringReportOtmItmList = ({ commit }, queryParams) => list(commit, queryParams, 'monitoringReportOtmItmList')
const files = ({ commit }, report) => axios.get(`/${endpoint}/${report.id}/monitoring_report_files/`).then(response => {
  commit('FILES', response.data)
})
const markReport = ({ state }, data) => new Promise((resolve, reject) => {
  axios.patch(`/${endpoint}/${data.id}/${data.status === state.ACCEPTED ? 'accept' : 'reject'}_report/`, {})
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const unmonitored = ({ commit }, data) => list(commit, data, 'orgUnmonitoredReports')
const del = (store, data) => axios.delete(`/${endpoint}/${data.id}/delete_report/`)

export default {
  ...Actions,
  monitoringReportAdvisorList,
  monitoringReportDoctorateList,
  monitoringReportInnovationList,
  monitoringReportOtmItmList,
  create,
  files,
  markReport,
  unmonitored,
  del,
}
